import ImportStudentListButton from 'pages/Organization/components/Invites/ImportStudentListButton/ImportStudentListButton';
import InviteStudentsButton from 'pages/Organization/components/Invites/InviteStudentsButton/InviteStudentsButton';
import Paragraph from 'components/TextComps/Paragraph';
import { useTranslation } from 'react-i18next';
import '../../EmptyState.scss';

export const NoStudentsFound = () => {
  const { t } = useTranslation();

  return (
    <div className='no-data-found'>
      <h2>{t('NoStudentsHaveJoinedThisClass', { ns: 'organizationPage' })}</h2>
      <Paragraph>
        <>{t('InviteStudentsOrResendInvitations', { ns: 'studentsPage' })}</>
      </Paragraph>
      <div className='buttons-wrapper'>
        <ImportStudentListButton intent='secondary' />
        <InviteStudentsButton intent='secondary' />
      </div>
    </div>
  );
};
